export const getConversationTitle = (row: any): React.ReactNode => {
    if(row.title){
        return row.title
    }else if (!row.title && row.messages && row.messages.length > 0) {
        return row.messages[0].content || 'Untitled';
    }
    return 'Untitled'
}

export const formatDateTime = (date: Date): string => {
    return new Date(date).toLocaleString('en-US', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric', 
        hour: 'numeric', 
        minute: 'numeric', 
        hour12: true 
    });
}

export const transformMessageObject = (obj: any): any => {
    return obj?.map((message: any) => ({
        ...message,
        fromDB: true,
        data: message.content,
        content: undefined
    }))
}

export const truncateString = (str: string, maxLength: number): string => {
    if (!str) return ''
    if (str.length > maxLength) {
        return str.substring(0, maxLength) + '...'
    }
    return str
}